
(function ($) {

    $.fn.camcomSidebar = function () {

        const init = function () {

            /** EXPAND/COLLAPSE SIDEBAR SECTIONS ON ARROW CLICK */
            $('.sidebar-nav__section__minimize, .sidebar-nav__section__sub-menu__minimize').on('click', function (event) {

                event.preventDefault();

                let sectionTrigger = $(this),
                    sectionTarget = $(sectionTrigger.attr('href'));

                if (!sectionTrigger.hasClass('is-animating')) {

                    sectionTrigger.addClass('is-animating');

                    let sectionTargetAutoHeight = sectionTarget.css('height', 'auto').height();

                    if (sectionTrigger.hasClass('is-closed')) {

                        sectionTarget.css('height', 0);

                        sectionTrigger.addClass('is-open');
                        sectionTrigger.removeClass('is-closed');
                        sectionTarget.removeClass('is-closed');

                        sectionTarget.animate({
                            height: sectionTargetAutoHeight,
                            overflow: 'visible',
                        }, 300, function () {

                            sectionTarget.css('height', 'auto');
                            sectionTrigger.removeClass('is-animating');

                        });


                    } else {

                        sectionTrigger.removeClass('is-open');

                        sectionTarget.animate({
                            overflow: 'hidden',
                            height: '0px'
                        }, 300, function () {


                            sectionTrigger.addClass('is-closed');
                            sectionTarget.addClass('is-closed');
                            sectionTrigger.removeClass('is-animating');

                        });

                    }

                }

            });


            /** MOBILE VIEWPORT SHOW/HIDE MENU */
            $('.js-sidebar__trigger').on('click', function (event) {

                event.preventDefault();

                let trigger = $(this),
                    sidebarTarget = $(trigger.attr('href'));

                if (trigger.hasClass('is-active')) {

                    sidebarTarget.removeClass('is-active').css('opacity', 0);
                    $(window).disablescroll('undo');

                } else {

                    $(window).disablescroll();
                    sidebarTarget.addClass('is-active');

                    sidebarTarget.animate({
                        opacity: 1
                    }, 200);


                }

            });

        };

        init();

        return this;

    }

}(jQuery));